import React, { createContext, useState, useEffect, useContext } from 'react';
import { userAxios, setupAxiosInterceptors } from '../userAxios';
import { UserContext } from './UserProvider';

const API_URL = process.env.REACT_APP_API_URL;

export const VendorFileContext = createContext();

export const VendorFileProvider = (props) => {
  const { token, handleInvalidToken } = useContext(UserContext);
  const [vendorFiles, setVendorFiles] = useState([]);
  const [fileTypes, setFileTypes] = useState([]);
  const [showEmpty, setShowEmpty] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [tableData, setTableData] = useState([]);
  const [sourceData, setSourceData] = useState([]);
  const [vendorId, setVendorId] = useState('');

  useEffect(() => {
    setupAxiosInterceptors(handleInvalidToken);
  }, [handleInvalidToken]);

  async function getVendorFiles(id) {
    try {
      const response = await userAxios.get(
        `${API_URL}/vendor/${id}/documents`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setVendorFiles(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  async function getFileTypes() {
    try {
      const response = await userAxios.get(`${API_URL}/documenttypes`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFileTypes(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  const deleteFile = async (id) => {
    try {
      const response = await userAxios.delete(`${API_URL}/document/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setVendorFiles(
        vendorFiles.filter((vendorFile) => vendorFile.rowKey !== id)
      );
      setShowEmpty(vendorFiles.length === 0);
      return response.data;
    } catch (err) {
      console.error(err);
    }
  };

  const handleFileUpload = async (formData, vendorId) => {
    if (!formData) return;
    setLoading(true);
    try {
      await userAxios.post(
        `${API_URL}/vendor/${vendorId}/documents`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLoading(false);
      getVendorFiles(vendorId);
      request();
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const downloadFile = async (row) => {
    try {
      const response = await userAxios.get(
        `${API_URL}/document/${row.rowKey}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob',
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', row.label);
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      alert(`Couldn't fetch file ${row.label}`);
    }
  };

  const request = () => {
    setTimeout(() => {
      setShowEmpty(tableData.length === 0);
    }, 1500);
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    const date = new Date(dateString);
    return date.toLocaleDateString(undefined, options);
  };

  const formatFileSize = (size) => {
    if (size < 1024) {
      return size + ' bytes';
    } else if (size < 1024 * 1024) {
      return (size / 1024).toFixed(0) + ' KB';
    } else if (size < 1024 * 1024 * 1024) {
      return (size / (1024 * 1024)).toFixed(0) + ' MB';
    } else if (size < 1024 * 1024 * 1024 * 1024) {
      return (size / (1024 * 1024 * 1024)).toFixed(0) + ' GB';
    } else {
      return (size / (1024 * 1024 * 1024 * 1024)).toFixed(0) + ' TB';
    }
  };

  useEffect(() => {}, [vendorFiles]);

  useEffect(() => {
    request();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorFiles]);

  useEffect(() => {
    setTableData(sourceData);
  }, [sourceData]);

  return (
    <VendorFileContext.Provider
      value={{
        vendorFiles,
        setVendorFiles,
        fileTypes,
        showEmpty,
        loading,
        isVisible,
        setIsVisible,
        searchValue,
        setSearchValue,
        tableData,
        setTableData,
        sourceData,
        setSourceData,
        vendorId,
        setVendorId,
        getFileTypes,
        getVendorFiles,
        deleteFile,
        handleFileUpload,
        downloadFile,
        request,
        formatDate,
        formatFileSize,
      }}
    >
      {props.children}
    </VendorFileContext.Provider>
  );
};

export default VendorFileProvider;
